// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════
   ThemeCrushPage — theme-specific styles only.
   Batch table / status pills / shimmer / tab-bar come from app.css.
   ═══════════════════════════════════════════════════════════ */

/* ── Sticky credits widget ──────────────────────────────── */
.tc-credits-top {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.92);
  padding: 8px 0;
  margin-top: -8px;
}

/* ── Theme card grid ────────────────────────────────────── */
.tc-theme-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.tc-theme-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  border: 2px solid var(--p-color-border, #e3e3e3);
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
  background: var(--p-color-bg, #fff);
  text-align: center;
  min-height: 110px;
  justify-content: center;
}

.tc-theme-card:hover {
  border-color: var(--p-color-border-emphasis, #999);
  background: var(--p-color-bg-surface-secondary, #f7f7f7);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.tc-theme-card-selected {
  border-color: var(--p-color-border-interactive, #005bd3) !important;
  background: #f0f6ff !important;
  box-shadow: 0 0 0 1px var(--p-color-border-interactive, #005bd3);
}

.tc-theme-card-main {
  border-style: solid;
}

.tc-theme-card-locked {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.tc-theme-card-loading {
  cursor: default;
  padding: 16px;
}

.tc-theme-card-icon {
  font-size: 28px;
  line-height: 1;
  margin-bottom: 2px;
}

.tc-theme-card-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--p-color-text, #202223);
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tc-theme-card-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}

.tc-theme-card-check {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 13px;
  color: var(--p-color-border-interactive, #005bd3);
  font-weight: 700;
}

/* ── Image row overrides ────────────────────────────────── */
.tc-image-row { cursor: pointer; }
.tc-row-selected   { background: #f0f4f9 !important; }
.tc-row-processing { background: #f5f8ff !important; cursor: default; }
.tc-row-queued     { background: #fafafa !important; cursor: default; opacity: 0.75; }
.tc-row-done       { background: #f5fbf8 !important; }

/* Thumbnail placeholder using Polaris icon */
.batch-thumb-placeholder-icon {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: var(--p-color-bg-surface-secondary, #f5f5f5);
  border: 1px solid var(--p-color-border, #e3e3e3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: help;
}

/* Image is referenced in theme but NOT found in Files library */
.batch-thumb-placeholder-icon.tc-thumb-missing {
  background: #fff8e6;
  border-color: #f0a500;
}

/* ── File info sub-line ─────────────────────────────────── */
.tc-origin-badge {
  display: inline-block;
  background: #e8f0fe;
  color: #1a4eba;
  font-size: 10px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  margin-right: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.tc-file-path {
  font-size: 11px;
  color: var(--p-color-text-subdued, #6d7175);
  font-family: 'SFMono-Regular', Consolas, monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 160px;
  display: inline-block;
  vertical-align: bottom;
}

/* Human-readable section › block › setting label */
.tc-section-label {
  font-size: 10px;
  color: #4a3a80;
  background: #ede8fc;
  border: 1px solid #c9b8f0;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  display: inline-block;
  vertical-align: bottom;
}

/* JSON settings path badge */
.tc-json-path {
  font-size: 10px;
  color: #6b4fa0;
  background: #f3edfc;
  border: 1px solid #d8c9f5;
  font-family: 'SFMono-Regular', Consolas, monospace;
  padding: 1px 6px;
  border-radius: 8px;
  cursor: default;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  display: inline-block;
  vertical-align: bottom;
}

/* Inline error text in actions column */
.tc-inline-error {
  font-size: 11px;
  color: var(--p-color-text-critical, #d72c0d);
  line-height: 1.3;
  cursor: help;
  word-break: break-word;
  max-width: 130px;
  display: block;
}

/* Ensure file name cell never bleeds into neighbour columns */
.batch-file-name-wrap { min-width: 0; overflow: hidden; }

.batch-file-sub {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 2px;
  min-width: 0;
  overflow: hidden;
}

/* ── Spin animation ─────────────────────────────────────── */
@keyframes tc-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.tc-spin { display: inline-block; animation: tc-spin 1s linear infinite; }

/* ── Batch actions cell ─────────────────────────────────── */
.tc-image-row .batch-actions {
  min-height: 34px;
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
}

/* ── Recent Theme Optimizations table ──────────────────── */
.tc-recents-header-row {
  display: grid;
  grid-template-columns: 44px minmax(120px, 1fr) minmax(100px, 1fr) 70px 80px 60px 100px 110px 90px;
  gap: 8px;
  align-items: center;
  padding: 8px 16px;
  background: var(--p-color-bg-surface-secondary, #f9fafb);
  border-bottom: 1px solid var(--p-color-border, #e3e3e3);
  font-size: 11px;
  font-weight: 600;
  color: var(--p-color-text-subdued, #6d7175);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.tc-recents-row {
  display: grid;
  grid-template-columns: 44px minmax(120px, 1fr) minmax(100px, 1fr) 70px 80px 60px 100px 110px 90px;
  gap: 8px;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid var(--p-color-border-subdued, #f0f0f0);
  transition: background 0.12s ease;
}

.tc-recents-row:last-child { border-bottom: none; }

.tc-recents-row:hover { background: var(--p-color-bg-surface-secondary, #f9fafb); }

.tc-recents-thumb {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  overflow: hidden;
  background: var(--p-color-bg-surface-secondary, #f5f5f5);
  border: 1px solid var(--p-color-border, #e3e3e3);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tc-recents-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ── Optimize confirm info box (used inside s-modal) ────── */
.tc-confirm-info-box {
  background: var(--p-color-bg-surface-secondary, #f9fafb);
  border: 1px solid var(--p-color-border, #e3e3e3);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tc-confirm-list {
  margin: 4px 0 4px 18px;
  padding: 0;
  font-size: 13px;
  color: var(--p-color-text, #202223);
  line-height: 1.7;
}

/* ── No-results empty state ─────────────────────────────── */
.tc-empty-state-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 52px 32px 44px;
  background: var(--p-color-bg, #fff);
  border: 1px solid var(--p-color-border, #e3e3e3);
  border-radius: 12px;
  text-align: center;
}

.tc-empty-state-icon {
  font-size: 60px;
  line-height: 1;
  margin-bottom: 4px;
  filter: grayscale(0.15);
}

.tc-empty-state-hints {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--p-color-bg-surface-secondary, #f9fafb);
  border: 1px solid var(--p-color-border-subdued, #f0f0f0);
  border-radius: 10px;
  padding: 16px 18px;
  text-align: left;
  max-width: 480px;
  width: 100%;
}

.tc-empty-hint-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.tc-empty-hint-icon {
  font-size: 15px;
  line-height: 1.5;
  flex-shrink: 0;
}

/* ── Live theme inline warning ──────────────────────────── */
.tc-live-theme-warning {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fff8e6;
  border: 1px solid #f5a623;
  border-radius: 8px;
  padding: 12px 14px;
}

.tc-live-theme-warning-icon {
  font-size: 18px;
  line-height: 1.2;
  flex-shrink: 0;
  color: #b95c00;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThemeCrushPage.css"],"names":[],"mappings":"AAAA;;;gEAGgE;;AAEhE,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gDAAgD;EAChD,mBAAmB;EACnB,eAAe;EACf,kEAAkE;EAClE,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;EAClD,wDAAwD;EACxD,yCAAyC;AAC3C;;AAEA;EACE,mEAAmE;EACnE,8BAA8B;EAC9B,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D,gBAAgB,eAAe,EAAE;AACjC,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,8BAA8B,EAAE,eAAe,EAAE;AACtE,qBAAqB,8BAA8B,EAAE,eAAe,EAAE,aAAa,EAAE;AACrF,qBAAqB,8BAA8B,EAAE;;AAErD,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;EACxD,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D,wBAAwB,YAAY,EAAE,gBAAgB,EAAE;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D,qBAAqB,OAAO,uBAAuB,EAAE,EAAE,KAAK,yBAAyB,EAAE,EAAE;AACzF,WAAW,qBAAqB,EAAE,qCAAqC,EAAE;;AAEzE,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,iGAAiG;EACjG,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,wDAAwD;EACxD,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iGAAiG;EACjG,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,+DAA+D;EAC/D,iCAAiC;AACnC;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD,wBAAwB,wDAAwD,EAAE;;AAElF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wDAAwD;EACxD,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,wDAAwD;EACxD,gDAAgD;EAChD,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mCAAmC;EACnC,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wDAAwD;EACxD,wDAAwD;EACxD,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB","sourcesContent":["/* ═══════════════════════════════════════════════════════════\n   ThemeCrushPage — theme-specific styles only.\n   Batch table / status pills / shimmer / tab-bar come from app.css.\n   ═══════════════════════════════════════════════════════════ */\n\n/* ── Sticky credits widget ──────────────────────────────── */\n.tc-credits-top {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.92);\n  padding: 8px 0;\n  margin-top: -8px;\n}\n\n/* ── Theme card grid ────────────────────────────────────── */\n.tc-theme-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n}\n\n.tc-theme-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 12px;\n  border: 2px solid var(--p-color-border, #e3e3e3);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n  background: var(--p-color-bg, #fff);\n  text-align: center;\n  min-height: 110px;\n  justify-content: center;\n}\n\n.tc-theme-card:hover {\n  border-color: var(--p-color-border-emphasis, #999);\n  background: var(--p-color-bg-surface-secondary, #f7f7f7);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.tc-theme-card-selected {\n  border-color: var(--p-color-border-interactive, #005bd3) !important;\n  background: #f0f6ff !important;\n  box-shadow: 0 0 0 1px var(--p-color-border-interactive, #005bd3);\n}\n\n.tc-theme-card-main {\n  border-style: solid;\n}\n\n.tc-theme-card-locked {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  pointer-events: none;\n}\n\n.tc-theme-card-loading {\n  cursor: default;\n  padding: 16px;\n}\n\n.tc-theme-card-icon {\n  font-size: 28px;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.tc-theme-card-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--p-color-text, #202223);\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  max-width: 100%;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tc-theme-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.tc-theme-card-check {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  font-size: 13px;\n  color: var(--p-color-border-interactive, #005bd3);\n  font-weight: 700;\n}\n\n/* ── Image row overrides ────────────────────────────────── */\n.tc-image-row { cursor: pointer; }\n.tc-row-selected   { background: #f0f4f9 !important; }\n.tc-row-processing { background: #f5f8ff !important; cursor: default; }\n.tc-row-queued     { background: #fafafa !important; cursor: default; opacity: 0.75; }\n.tc-row-done       { background: #f5fbf8 !important; }\n\n/* Thumbnail placeholder using Polaris icon */\n.batch-thumb-placeholder-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  background: var(--p-color-bg-surface-secondary, #f5f5f5);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: help;\n}\n\n/* Image is referenced in theme but NOT found in Files library */\n.batch-thumb-placeholder-icon.tc-thumb-missing {\n  background: #fff8e6;\n  border-color: #f0a500;\n}\n\n/* ── File info sub-line ─────────────────────────────────── */\n.tc-origin-badge {\n  display: inline-block;\n  background: #e8f0fe;\n  color: #1a4eba;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 1px 6px;\n  border-radius: 8px;\n  margin-right: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.tc-file-path {\n  font-size: 11px;\n  color: var(--p-color-text-subdued, #6d7175);\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 160px;\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n/* Human-readable section › block › setting label */\n.tc-section-label {\n  font-size: 10px;\n  color: #4a3a80;\n  background: #ede8fc;\n  border: 1px solid #c9b8f0;\n  font-weight: 600;\n  padding: 1px 6px;\n  border-radius: 8px;\n  cursor: default;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 180px;\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n/* JSON settings path badge */\n.tc-json-path {\n  font-size: 10px;\n  color: #6b4fa0;\n  background: #f3edfc;\n  border: 1px solid #d8c9f5;\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  padding: 1px 6px;\n  border-radius: 8px;\n  cursor: default;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 160px;\n  display: inline-block;\n  vertical-align: bottom;\n}\n\n/* Inline error text in actions column */\n.tc-inline-error {\n  font-size: 11px;\n  color: var(--p-color-text-critical, #d72c0d);\n  line-height: 1.3;\n  cursor: help;\n  word-break: break-word;\n  max-width: 130px;\n  display: block;\n}\n\n/* Ensure file name cell never bleeds into neighbour columns */\n.batch-file-name-wrap { min-width: 0; overflow: hidden; }\n\n.batch-file-sub {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  margin-top: 2px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* ── Spin animation ─────────────────────────────────────── */\n@keyframes tc-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }\n.tc-spin { display: inline-block; animation: tc-spin 1s linear infinite; }\n\n/* ── Batch actions cell ─────────────────────────────────── */\n.tc-image-row .batch-actions {\n  min-height: 34px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-start;\n}\n\n/* ── Recent Theme Optimizations table ──────────────────── */\n.tc-recents-header-row {\n  display: grid;\n  grid-template-columns: 44px minmax(120px, 1fr) minmax(100px, 1fr) 70px 80px 60px 100px 110px 90px;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 16px;\n  background: var(--p-color-bg-surface-secondary, #f9fafb);\n  border-bottom: 1px solid var(--p-color-border, #e3e3e3);\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--p-color-text-subdued, #6d7175);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.tc-recents-row {\n  display: grid;\n  grid-template-columns: 44px minmax(120px, 1fr) minmax(100px, 1fr) 70px 80px 60px 100px 110px 90px;\n  gap: 8px;\n  align-items: center;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--p-color-border-subdued, #f0f0f0);\n  transition: background 0.12s ease;\n}\n\n.tc-recents-row:last-child { border-bottom: none; }\n\n.tc-recents-row:hover { background: var(--p-color-bg-surface-secondary, #f9fafb); }\n\n.tc-recents-thumb {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--p-color-bg-surface-secondary, #f5f5f5);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.tc-recents-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* ── Optimize confirm info box (used inside s-modal) ────── */\n.tc-confirm-info-box {\n  background: var(--p-color-bg-surface-secondary, #f9fafb);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  border-radius: 8px;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.tc-confirm-list {\n  margin: 4px 0 4px 18px;\n  padding: 0;\n  font-size: 13px;\n  color: var(--p-color-text, #202223);\n  line-height: 1.7;\n}\n\n/* ── No-results empty state ─────────────────────────────── */\n.tc-empty-state-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 52px 32px 44px;\n  background: var(--p-color-bg, #fff);\n  border: 1px solid var(--p-color-border, #e3e3e3);\n  border-radius: 12px;\n  text-align: center;\n}\n\n.tc-empty-state-icon {\n  font-size: 60px;\n  line-height: 1;\n  margin-bottom: 4px;\n  filter: grayscale(0.15);\n}\n\n.tc-empty-state-hints {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: var(--p-color-bg-surface-secondary, #f9fafb);\n  border: 1px solid var(--p-color-border-subdued, #f0f0f0);\n  border-radius: 10px;\n  padding: 16px 18px;\n  text-align: left;\n  max-width: 480px;\n  width: 100%;\n}\n\n.tc-empty-hint-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.tc-empty-hint-icon {\n  font-size: 15px;\n  line-height: 1.5;\n  flex-shrink: 0;\n}\n\n/* ── Live theme inline warning ──────────────────────────── */\n.tc-live-theme-warning {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: #fff8e6;\n  border: 1px solid #f5a623;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.tc-live-theme-warning-icon {\n  font-size: 18px;\n  line-height: 1.2;\n  flex-shrink: 0;\n  color: #b95c00;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
